<template>
  <div>
    <div class="table--header">
      <div></div>
      <div>
        <a-input v-model="url" placeholder="Phising attack link"></a-input>

        <p style="color: red; margin-top: 10px"> {{ siteMsg }} </p>
      </div>
    </div>
    <div style="margin-top: 15px" v-if="site">
      <a-card>
        <span slot="title"> Site Found </span>
        <a-row :gutter="16">
          <a-col>
            <div class="card" style="height: 97%">
              <div class="card-body">
                <div class="h5">Name:
                  <router-link :to="{name:'sites.overview',params:{siteId:site.id}}"> {{ site.name }} </router-link>
                </div>
                <div class="h5">URL: <a :href="site.site_url" target="_blank">{{ site.site_url }}</a></div>
                <div class="h5">email: {{ site.email }}</div>
                <div class="h5">Created: {{ site.created_at }}</div>
                <div style="margin-bottom: 10px">Campaign Link: <a :href="campaignLink">{{ campaignLink }} </a></div>
                <a-badge v-if="site.deactivated_at" :count="'Disconnected at: ' + site.deactivated_at" :number-style="{ backgroundColor: '#e9452c' }" />
                <a-badge v-else count="Connected with weMail" :number-style="{ backgroundColor: '#52c41a' }" />
                <a-button style="margin-left: 10px;" type="danger" icon="warning" @click.prevent="blockSite">
                  Block
                </a-button>
                <h3> {{ successMsg}} </h3>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </div>
  </div>
</template>
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
      url: '',
      site: '',
      campaignLink: '',
      successMsg: '',
      siteMsg: ''
    }
  },
  watch: {
    url(val) {
      this.siteMsg = '';
      try {
        let urlObject = new URL(val);
        let siteId;

        if (urlObject.hostname.includes('wemailtrack.com')) {
          const hostnameParts = urlObject.hostname.split('-');
          siteId = hostnameParts[hostnameParts.length - 1].split('.')[0]; // Extract siteId

          const pathParts = urlObject.pathname.split('/');
          const campaignWithHash = pathParts[1]; // Get the part after first '/'
          const campaignId = campaignWithHash.split(':')[0];

          this.campaignLink = `${process.env.VUE_APP_ENDPOINT}campaigns/${campaignId}`;

          if (siteId) {
            Api.get(`/subscriber-site/${siteId}`).then(res => {
              if (res.data.site) {
                this.site = res.data.site;
              }
              if (res.data.message) {
                this.siteMsg = res.data.message;
              }
            });
          }
        } else {

          // Get the value of the 'redirect-to' parameter
          let urlSplit = urlObject.pathname.split('/');
          let subscriberId = urlSplit.pop();
          let redirectToIndex = urlSplit.indexOf('redirect-to');
          this.campaignLink = process.env.VUE_APP_ENDPOINT + 'campaigns/' + urlSplit[redirectToIndex + 1].split(':')[0];

          if (subscriberId) {
            Api.get(`/subscriber-site/${subscriberId}`).then(res => {
              if (res.data.site) {
                this.site = res.data.site;
              }
              if (res.data.message) {
                this.siteMsg = res.data.message;
              }
            })
          }
        }
      } catch (error) {
        console.error('Invalid URL format:', error);
      }
    },
  },
  methods: {
    blockSite() {
      Api.post(`/sites/${this.site.id}`,{data: 'block'}).then(res => {
        this.successMsg = res.data.message;
      })
    }
  }
}
</script>